import api from '@/api'
import Report, { UnsupportedMediaTypeReport } from '@/api/communique/report'
import types from '@/types'

//Subject to be modified as more stats are added
export interface CompanyTotalStats {
  excluded_clicks: number
  excluded_impressions: number
  impressions: number
  clicks: number
}
interface queryParams {
  companyId: string
  mediaTypes: string[]
  startDate?: string
  endDate?: string
  excludedInitiativeIDs?: string[]
  includedInitiativeIDs?: string[]
}

export class CompanyTotalStatsModel {
  public async fetch({
    companyId,
    mediaTypes,
    startDate,
    endDate,
    excludedInitiativeIDs,
    includedInitiativeIDs,
  }: queryParams): Promise<Report<CompanyTotalStats> | UnsupportedMediaTypeReport> {
    return api('report.dashboards.ihmCompany.companyTotalStats')
      .params({
        companyId: companyId,
        media_types: mediaTypes,
        start_date: startDate,
        end_date: endDate,
        exclude_initiative_ids: excludedInitiativeIDs,
        include_initiative_ids: includedInitiativeIDs,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<CompanyTotalStats>>()
  }
}
